var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mx-auto order-by",attrs:{"max-width":"700"}},[_c('v-slide-group',{attrs:{"show-arrows":""}},_vm._l((_vm.lstOrder),function(value){return _c('v-slide-item',{key:value.active},[_c('div',{staticClass:"item"},[_c('a',{style:({
            color: _vm.active == value.active ? _vm.text_color : 'rgba(0,0,0,.6)',
          }),on:{"click":function($event){_vm.active = value.active;
            _vm.OrderProuct(value.orderBy, value.sortBy, value.isFavorite);}}},[_vm._v(" "+_vm._s(_vm.$t(value.title)))])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }